import { HubConnection, HubConnectionBuilder, HttpTransportType } from '@microsoft/signalr';

const baseUrl = import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, '');
const projectKey = import.meta.env.VITE_X_BLOCKS_KEY || '';

let connection: HubConnection | null = null;
const subscriptions = new Map<string, number>();

const getConnection = () => {
  if (!baseUrl || !projectKey) {
    return null;
  }

  if (!connection) {
    connection = new HubConnectionBuilder()
      .withUrl(`${baseUrl}/communication/v1/NotificationHub?x-blocks-key=${projectKey}`, {
        transport: HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect()
      .build();
  }

  if (connection.state === 'Disconnected') {
    connection.start().catch((error) => {
      console.error('Notification connection failed', error);
    });
  }

  return connection;
};

export const ensureNotificationSubscription = (notificationName: string) => {
  const hub = getConnection();
  if (!hub) {
    return () => undefined;
  }

  if (!subscriptions.has(notificationName)) {
    hub.on(notificationName, (message: string) => {
      window.dispatchEvent(
        new CustomEvent(notificationName, {
          detail: {
            method: notificationName,
            message,
            timestamp: new Date().toISOString(),
          },
        })
      );
    });
    subscriptions.set(notificationName, 0);
  }

  subscriptions.set(notificationName, (subscriptions.get(notificationName) ?? 0) + 1);

  return () => {
    const nextCount = (subscriptions.get(notificationName) ?? 1) - 1;
    if (nextCount <= 0) {
      hub.off(notificationName);
      subscriptions.delete(notificationName);
      return;
    }
    subscriptions.set(notificationName, nextCount);
  };
};
